import React from "react";

export function Field({ label, children, required, htmlFor, hint }) {
  return (
    <div>
      <label htmlFor={htmlFor} className="text-sm text-slate-300">
        {label}
        {required && <span className="text-rose-400 ml-1">*</span>}
      </label>
      <div className="mt-1">{children}</div>
      {hint && <p className="text-xs text-slate-500 mt-1">{hint}</p>}
    </div>
  );
}

export function Input({ testid, ...props }) {
  return (
    <input
      data-testid={testid}
      {...props}
      className={
        "w-full px-4 py-2.5 rounded-lg bg-[#0E1A3A] border border-slate-700 focus:border-sky-400 focus:ring-1 focus:ring-sky-400 text-slate-100 outline-none placeholder:text-slate-500 " +
        (props.className || "")
      }
    />
  );
}

export function Select({ testid, children, ...props }) {
  return (
    <select
      data-testid={testid}
      {...props}
      className={
        "w-full px-4 py-2.5 rounded-lg bg-[#0E1A3A] border border-slate-700 focus:border-sky-400 focus:ring-1 focus:ring-sky-400 text-slate-100 outline-none " +
        (props.className || "")
      }
    >
      {children}
    </select>
  );
}

export function Checkbox({ testid, children, checked, onChange, ...props }) {
  return (
    <label className="flex items-start gap-2 text-sm text-slate-300 cursor-pointer select-none">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        data-testid={testid}
        className="mt-0.5 w-4 h-4 rounded border-slate-600 bg-[#0E1A3A] text-sky-500 focus:ring-sky-400"
        {...props}
      />
      <span className="leading-relaxed">{children}</span>
    </label>
  );
}

export function SubmitButton({ loading, children, testid }) {
  return (
    <button
      type="submit"
      disabled={loading}
      data-testid={testid}
      className="w-full mt-3 px-4 py-2.5 rounded-lg bg-gradient-to-r from-sky-500 to-indigo-500 text-white font-medium hover:opacity-95 disabled:opacity-60 transition"
    >
      {loading ? "Creating account…" : children}
    </button>
  );
}

export function ErrorBanner({ error }) {
  if (!error) return null;
  return (
    <div
      className="text-sm text-rose-300 bg-rose-500/10 border border-rose-500/30 rounded-md px-3 py-2"
      data-testid="signup-error"
    >
      {error}
    </div>
  );
}

export function CommonIdentityFields({ values, onChange, testidPrefix = "signup" }) {
  return (
    <>
      <Field label="Full name" required htmlFor={`${testidPrefix}-full_name`}>
        <Input
          id={`${testidPrefix}-full_name`}
          testid={`${testidPrefix}-full_name`}
          required
          value={values.full_name}
          onChange={(e) => onChange("full_name", e.target.value)}
          placeholder="Jane Doe"
        />
      </Field>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field label="Email" required htmlFor={`${testidPrefix}-email`}>
          <Input
            id={`${testidPrefix}-email`}
            testid={`${testidPrefix}-email`}
            type="email"
            required
            value={values.email}
            onChange={(e) => onChange("email", e.target.value)}
            placeholder="you@example.com"
          />
        </Field>
        <Field label="Phone" required htmlFor={`${testidPrefix}-phone`}>
          <Input
            id={`${testidPrefix}-phone`}
            testid={`${testidPrefix}-phone`}
            type="tel"
            required
            value={values.phone}
            onChange={(e) => onChange("phone", e.target.value)}
            placeholder="+91 98765 43210"
          />
        </Field>
      </div>
      <Field label="Password" required htmlFor={`${testidPrefix}-password`} hint="Min 8 characters.">
        <Input
          id={`${testidPrefix}-password`}
          testid={`${testidPrefix}-password`}
          type="password"
          required
          minLength={8}
          value={values.password}
          onChange={(e) => onChange("password", e.target.value)}
          placeholder="••••••••"
        />
      </Field>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field label="Country" required htmlFor={`${testidPrefix}-country`}>
          <Input
            id={`${testidPrefix}-country`}
            testid={`${testidPrefix}-country`}
            required
            value={values.country}
            onChange={(e) => onChange("country", e.target.value)}
            placeholder="India"
          />
        </Field>
        <Field label="Timezone" required htmlFor={`${testidPrefix}-timezone`}>
          <Input
            id={`${testidPrefix}-timezone`}
            testid={`${testidPrefix}-timezone`}
            required
            value={values.timezone}
            onChange={(e) => onChange("timezone", e.target.value)}
            placeholder="Asia/Kolkata"
          />
        </Field>
      </div>
    </>
  );
}
